import React from 'react';
import classNames from 'classnames';
import './Badge.css';

const Badge = ({
    children,
    variant = 'default',
    size = 'md',
    className,
    ...props
}) => {
    const badgeClasses = classNames(
        'badge',
        `badge-${variant}`,
        `badge-${size}`,
        className
    );

    return (
        <span className={badgeClasses} {...props}>
            {children}
        </span>
    );
};

export default Badge;
